import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { checkUserSubscription, getUserSettings } from "../services/userSettings";

export const useGetUserSettings = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.USER_SETTINGS, language],
    queryFn: getUserSettings,
  });
};

export const useCheckUserSubscription = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.USER_SUBSCRIPTION, language],
    queryFn: checkUserSubscription,
  });
};
